import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import Select from 'react-select';
import { Mission } from '../../../db';

interface PolyMergeWithOption {
  label: string;
  value: string;
}

interface PolysMergeDialogProps {
  open: boolean;
  mission: Mission;
  zoneId: number;
  polyId: number;
  onClose: () => void;
  onMergeClick: (selectedPolyId: number, mergeWithPolyId: number) => void;
}

const PolysMergeDialog: React.FC<PolysMergeDialogProps> = ({
  open,
  mission,
  zoneId,
  polyId,
  onClose,
  onMergeClick,
}) => {
  const selectedZone = mission.getZoneById(zoneId);

  const mergeWithOptions = selectedZone?.getPolysGroupedByPolyId()
    ? Object.keys(selectedZone.getPolysGroupedByPolyId())
        .map((key) => parseInt(key))
        .filter((id) => id !== polyId)
        .map((id) => ({
          label: `Poly ${id}`,
          value: id.toString(),
        }))
    : [];

  const [polyToMergeWith, setPolyToMergeWith] = useState<PolyMergeWithOption | null>(null);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          minHeight: '200px',
          minWidth: '300px',
          height: 'auto',
        },
      }}
    >
      <DialogTitle>{selectedZone ? `Merge poly ${polyId} with` : 'No Zone Selected'}</DialogTitle>

      <DialogContent dividers style={{ minHeight: '150px', paddingBottom: '20px' }}>
        <Select
          value={polyToMergeWith}
          onChange={(option) => setPolyToMergeWith(option as PolyMergeWithOption)}
          options={mergeWithOptions}
          isSearchable
          placeholder="Choose a poly......"
          menuPortalTarget={document.body}
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
            }),
            menuPortal: (provided) => ({
              ...provided,
              zIndex: 9999,
            }),
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button
          disabled={!polyToMergeWith}
          onClick={() => {
            if (!selectedZone || !polyToMergeWith || !polyToMergeWith.value) {
              return;
            }

            onMergeClick(polyId, Number(polyToMergeWith.value));
          }}
          color="primary"
          variant="outlined"
        >
          Merge
        </Button>

        <Button onClick={onClose} color="secondary" variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PolysMergeDialog;
